import { Component, Input, Output, EventEmitter, Self, Optional } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import { EditAddressDialogComponent } from '../../../dialogs/edit-address-dialog/edit-address-dialog.component';

@Component({
    selector: 'app-address-card',
    templateUrl: './address-card.component.html',
    styleUrls: ['./address-card.component.scss'],
})
export class AddressCardComponent implements ControlValueAccessor {
    public onChange: Function;
    public onTouched: Function;
    public _value: any = '';

    @Input() disableMessages: boolean = false;
    @Output('change') changeOutput = new EventEmitter<any>();
    @Output() toggleCurrentDialogVisibility: EventEmitter<void> = new EventEmitter<void>();
    @Output() selectedAddressChange: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private dialog: MatDialog,
        @Self() @Optional() private ngControl: NgControl,
    ) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    get formattedAddress() {
        if (!this._value) {
            return '';
        }
        return `${this._value.unit} ${this._value.number} ${this._value.street}, ${this._value.city}, ${this._value.province}, ${this._value.postCode}`;
    }

    get invalid() {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid() {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine() {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty() {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched() {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;

        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(v) {
        this._value = v;
    }

    writeValue(value: any): void {
        this.value = value;
        this.selectedAddressChange.emit(this.formattedAddress);
    }

    editAddress() {
        this.toggleCurrentDialogVisibility.emit();

        const dialogRef = this.dialog.open(EditAddressDialogComponent, {
            panelClass: 'bciti-dialog',
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.writeValue(result);
            }

            this.toggleCurrentDialogVisibility.emit();
        });
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }
}
